import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceiptDollar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "receipt-dollar" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6,
			y1: 6.75,
			x2: 12,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6,
			y1: 11.25,
			x2: 9.75,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6,
			y1: 15.75,
			x2: 9.75,
			y2: 15.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.5,
			y1: 6.75,
			x2: 18,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.892,16.564a2.221,2.221,0,0,0,1.858.875c1.139,0,2.062-.693,2.062-1.547s-.923-1.547-2.062-1.547-2.063-.693-2.063-1.548.924-1.547,2.063-1.547a2.223,2.223,0,0,1,1.858.875"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.75,
			y1: 17.439,
			x2: 15.75,
			y2: 18.469
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.75,
			y1: 10.22,
			x2: 15.75,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.5,23.25a2.605,2.605,0,0,1,4.5,0V.75a2.614,2.614,0,0,1-2.25,1.293A2.613,2.613,0,0,1,16.5.75a2.614,2.614,0,0,1-2.25,1.293A2.613,2.613,0,0,1,12,.75,2.614,2.614,0,0,1,9.75,2.043,2.613,2.613,0,0,1,7.5.75,2.614,2.614,0,0,1,5.25,2.043,2.613,2.613,0,0,1,3,.75v22.5a2.605,2.605,0,0,1,4.5,0,2.605,2.605,0,0,1,4.5,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,23.25a2.605,2.605,0,0,1,4.5,0"
		})
	]
});
export default SvgReceiptDollar;
